module.exports = __webpack_public_path__ + "b76ec4a33fc01a44766244f0f875b262.svg";